import type { Fallacy } from "./types";
import { createStory } from "./types";

export const lossAversion: Fallacy = {
    id: "loss-aversion",
    name: "Loss Aversion",
    emoji: "😰",
    category: "Otak yang Menipu Diri",
    description: "**Takut kehilangan** terasa **jauh lebih kuat** daripada kesenangan mendapatkan sesuatu bernilai sama.",
    tldr: "Takut rugi 10 ribu lebih nyesek daripada senang dapat 10 ribu.",
    detail: "Loss Aversion adalah bias kognitif di mana rasa sakit kehilangan secara psikologis terasa **dua kali lebih kuat** dibandingkan kesenangan mendapatkan sesuatu setara. Diteliti oleh Kahneman dan Tversky, bias ini membuat manusia mengambil keputusan berdasarkan potensi kerugian, bukan hasil akhir.\n\nContoh: hold saham yang turun 50% karena gak mau \"realize\" kerugian, atau tetap langganan layanan yang sudah tidak dipakai. Di dunia bisnis, bias ini dimanfaatkan lewat framing \"Penawaran berakhir hari ini!\" — membuat kita merasa akan kehilangan, padahal sebenarnya tidak.\n\nCara melawan: **Evaluasi keputusan berdasarkan nilai absolut**, bukan relatif terhadap apa yang sudah kamu punya. Tanya: \"Kalau aku belum punya ini, apakah aku akan membelinya?\"",
    story: createStory("Loss Aversion", "😰", {
      hook: {
        title: "Kamu pernah ngerasa gini gak?",
        body: "Kehilangan 50 ribu tuh nyesekin banget. Tapi nemu 50 ribu? Biasa aja. Kenapa ya?",
      },
      convo: {
        claim: "Dapet tawaran kerja baru, gaji naik 30% dan bisa WFH. Tapi aku milih stay, **takut pindah terus ternyata gak cocok** dan nyesel.",
        response: "Kamu bukan milih yang lebih baik. **Kamu cuma takut kehilangan yang udah ada.**",
      },
      reveal: {
        body: "Otak kamu menilai **kerugian 2x lebih sakit** daripada kesenangan dari keuntungan yang sama. Makanya kamu lebih fokus hindari rugi daripada cari untung.",
      },
      insight: {
        title: "Kenapa bahaya?",
        body: "Kamu jadi **hold hal-hal yang harusnya dilepas** — saham busuk, langganan gak kepake, bahkan zona nyaman yang gak berkembang. Semua karena takut rugi.",
      },
      engagement: {
        title: "Pernah gak ambil peluang bagus karena takut rugi?",
        body: "Soal karir, investasi, atau hubungan? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["sunk-cost", "status-quo-bias", "framing-effect", "anchoring-bias"],
  };
